import * as React from 'react';
import { connect } from 'react-redux';
import { navigate } from '~/router';

import OrgListHeader from '../../components/orgs/OrgListHeader';


class OrgHeader extends React.Component<any, any> {
  onCreateOrg = (e) => {
    e.preventDefault();
  };

  render() {
    return (
      <OrgListHeader onCreateOrganization={this.onCreateOrg} />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    orgs: state.shared.organizations,
  }
};

const mapDispatchToProps = (dispatch: Function, { history }) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgHeader) as any;
